import { useCallback, useEffect, useRef } from 'react';

interface UseBroadcastChannelProps {
  channelName: string;
}

export const useBroadcastChannel = <T = any>({ channelName }: UseBroadcastChannelProps) => {
  const channelRef = useRef<BroadcastChannel | null>(null);

  const broadcast = (data: T) => {
    channelRef.current?.postMessage(data);
  };

  const addListener = useCallback(
    (onMessage: (data: T) => void) => {
      const handler = (event: MessageEvent) => {
        onMessage(event.data);
      };

      channelRef.current?.addEventListener('message', handler);

      return () => {
        channelRef.current?.removeEventListener('message', handler);
      };
    },
    [channelRef.current],
  );

  useEffect(() => {
    if (channelRef.current) {
      channelRef.current.close();
    }
    channelRef.current = new BroadcastChannel(channelName);
    return () => {
      channelRef.current?.close();
    };
  }, [channelName]);

  return { broadcast, addListener };
};
